import { defineGameCard, modifyOutgoingDamage } from '../authoring/index.js';
export const MercenarySpearmanCard = defineGameCard({
    id: 'mercenary_spearman',
    gameplay: { type: 'UNIT', cost: 3, baseStats: { attack: 3, health: 4 } },
    presentation: {
        name: 'Наёмный копейщик',
        description: 'В бою против бойца с атакой 4 или больше наносит на 1 больше урона.',
        glyph: {
            colors: ['#A86C46', '#10213A', '#2C1E20', '#263345', '#702E1F'],
            rows: [
                '....................',
                '...............1....',
                '......22222...11....',
                '.....2344442..111...',
                '....233333442.11....',
                '....233333332.11....',
                '....231212132..4....',
                '....231111132..3....',
                '....231111132..3....',
                '....244111122..3....',
                '....2544455452.3....',
                '...2555444455523....',
                '..25555555555523....',
                '..24455555555423....',
                '..244444444444151...',
                '.2444444444443551...',
                '.2444344444443555...',
                '.255534444444333....',
                '.2555333333333.3....',
                '.2551344444443.3....',
            ],
        },
    },
    role: 'playable',
    abilities: [modifyOutgoingDamage((ctx, planned) => {
            if ((planned.origin !== 'ordinary_attack' && planned.origin !== 'extra_attack')
                || planned.target.kind !== 'unit')
                return planned.amount;
            const target = ctx.q.instance(planned.target.instanceId);
            return target !== null && ctx.q.cardType(target.id) === 'UNIT' && ctx.q.stats(target).attack >= 4
                ? planned.amount + 1
                : planned.amount;
        })],
});
//# sourceMappingURL=mercenary_spearman.js.map